import { useEffect, useState } from 'react';
import { FirestoreDocument } from '../../types';
import { documentToJsonString, getEditorTheme } from './json-editor-modal.domain';

export interface JsonEditorModalProps {
  document: FirestoreDocument | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function useJsonEditorModal({
  document,
  open,
  onOpenChange,
}: JsonEditorModalProps) {
  const [jsonString, setJsonString] = useState('');
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDark(window.document.documentElement.classList.contains('dark'));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(window.document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (document && open) {
      setJsonString(documentToJsonString(document));
    }
  }, [document, open]);

  const handleClose = () => onOpenChange(false);

  useEffect(() => {
    if (!open) return;
    const doc = globalThis.document;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      onOpenChange(false);
    };
    doc.addEventListener('keydown', onKeyDown, true);
    return () => doc.removeEventListener('keydown', onKeyDown, true);
  }, [open, onOpenChange]);

  return {
    open,
    onOpenChange,
    jsonString,
    theme: getEditorTheme(isDark),
    handleClose,
  };
}
